"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var prefetch_1 = require("./prefetch");
var prefetchQueue = [];
var prefetchRequestPending = false;
function throttledFetch(url, init) {
    // Non-prefetch requests are always sent immediately
    if (!prefetch_1.isInPrefetchMode()) {
        return fetch(url, init).catch(function (error) {
            if (error.message) {
                error.message = error.message + ". URL: " + url;
            }
            error.retriable = true;
            error.fetchErrorType = 'RequestNotComplete';
            return Promise.reject(error);
        });
    }
    // Return a promise that will be resolved after the request has been sent and returned
    return new Promise(function (resolve, reject) {
        prefetchQueue.push({
            url: url,
            init: init,
            resolve: resolve,
            reject: reject
        });
        runPrefetchQueue();
    });
}
exports.default = throttledFetch;
function runPrefetchQueue() {
    if (!prefetchRequestPending && prefetchQueue.length) {
        prefetchRequestPending = true;
        var nextPrefetch_1 = prefetchQueue.shift();
        fetch(nextPrefetch_1.url, nextPrefetch_1.init).then(function (response) {
            prefetchRequestPending = false;
            nextPrefetch_1.resolve(response);
            runPrefetchQueue();
        }, function (reason) {
            prefetchRequestPending = false;
            nextPrefetch_1.reject(reason);
            runPrefetchQueue();
        });
    }
}
